import ColorEditor from './ColorEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('color-editor', ColorEditor)
  }
}